export const backendUrl = process.env.REACT_APP_BACKEND_URL
export const tfaTokenKey = 'x-tfa-auth-token'
